(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arduino-demo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const BAUD_RATE = 115200;
    const RESET_DELAY_MS = 1900;

    const sleep = (milliseconds) =>
      new Promise((resolve) => window.setTimeout(resolve, milliseconds));

    function initializeDashboard(panel) {
      if (panel.dataset.ctInitialized === 'true') return;
      panel.dataset.ctInitialized = 'true';

      const connectButton = panel.querySelector('[data-connect]');
      const commandButtons = Array.from(panel.querySelectorAll('[data-command]'));
      const showButton = panel.querySelector('[data-show-button]');
      const showLabel = panel.querySelector('[data-show-label]');
      const scanButton = panel.querySelector('[data-scan-button]');
      const connectionStatus = panel.querySelector('[data-connection-status]');
      const calibrationStatus = panel.querySelector('[data-calibration-status]');
      const dashboardMessage = panel.querySelector('[data-dashboard-message]');
      const colorSwatch = panel.querySelector('[data-color-swatch]');
      const swatchPlaceholder = panel.querySelector('[data-swatch-placeholder]');
      const colorName = panel.querySelector('[data-color-name]');
      const hexValue = panel.querySelector('[data-hex-value]');
      const rgbValue = panel.querySelector('[data-rgb-value]');
      const confidenceValue = panel.querySelector('[data-confidence-value]');
      const illuminationValue = panel.querySelector('[data-illumination-value]');
      const speakButton = panel.querySelector('[data-speak-result]');
      const startCalibrationButton = panel.querySelector('[data-start-calibration]');
      const resetCalibrationButton = panel.querySelector('[data-reset-calibration]');
      const calibrationModal = panel.querySelector('[data-calibration-modal]');
      const calibrationTitle = panel.querySelector('[data-calibration-title]');
      const calibrationText = panel.querySelector('[data-calibration-text]');
      const calibrationDetail = panel.querySelector('[data-calibration-detail]');
      const calibrationNext = panel.querySelector('[data-calibration-next]');
      const calibrationCancel = panel.querySelector('[data-calibration-cancel]');
      const progressOne = panel.querySelector('[data-progress-one]');
      const progressTwo = panel.querySelector('[data-progress-two]');

      const state = {
        connected: false,
        stripOn: false,
        showOn: false,
        mode: 'night',
        calibrated: false,
        busy: false,
        colorName: '',
        hex: '#000000'
      };

      let port = null;
      let reader = null;
      let writer = null;
      let readPromise = null;
      let keepReading = false;
      let serialBuffer = '';
      let calibrationStage = 'idle';
      let lastCalibrationDetail = '';

      const encoder = new TextEncoder();
      const decoder = new TextDecoder();

      function setMessage(text) {
        dashboardMessage.textContent = text;
      }

      function setCalibrationReady(isReady) {
        state.calibrated = Boolean(isReady);
        calibrationStatus.classList.toggle('is-ready', state.calibrated);
        calibrationStatus.textContent = state.calibrated
          ? 'Sensor calibrado'
          : 'Sensor pendiente de calibración';
      }

      function setBusy(isBusy) {
        state.busy = Boolean(isBusy);
        scanButton.disabled = !state.connected || state.busy;
        startCalibrationButton.disabled = !state.connected || state.busy;
        resetCalibrationButton.disabled = !state.connected || state.busy;
      }

      function renderConnection() {
        panel.classList.toggle('is-connected', state.connected);
        connectionStatus.textContent = state.connected
          ? 'Arduino conectado'
          : 'Arduino desconectado';
        connectButton.textContent = state.connected
          ? 'Desconectar Arduino'
          : 'Conectar Arduino';

        commandButtons.forEach((button) => {
          button.disabled = !state.connected || state.busy;
        });

        startCalibrationButton.disabled = !state.connected || state.busy;
        resetCalibrationButton.disabled = !state.connected || state.busy;
      }

      function renderDeviceState() {
        showButton.classList.toggle('is-active', state.showOn);
        showButton.setAttribute('aria-pressed', String(state.showOn));
        showLabel.textContent = state.showOn ? 'Detener show' : 'Show elegante';

        panel.querySelectorAll('[data-mode]').forEach((button) => {
          const active = state.stripOn && !state.showOn && button.dataset.mode === state.mode;
          button.classList.toggle('is-active', active);
        });

        const powerOn = panel.querySelector('[data-control-kind="power-on"]');
        const powerOff = panel.querySelector('[data-control-kind="power-off"]');

        powerOn.classList.toggle('is-active', state.stripOn && !state.showOn);
        powerOff.classList.toggle('is-active', !state.stripOn);
        setCalibrationReady(state.calibrated);
        renderConnection();
      }

      function applyDeviceState(data) {
        if (typeof data.stripOn === 'boolean') state.stripOn = data.stripOn;
        if (typeof data.showOn === 'boolean') state.showOn = data.showOn;
        if (typeof data.mode === 'string') state.mode = data.mode;
        if (typeof data.calibrated === 'boolean') state.calibrated = data.calibrated;
        renderDeviceState();
      }

      function updateColorResult(data) {
        const safeHex = /^#[0-9A-F]{6}$/i.test(data.hex) ? data.hex.toUpperCase() : '#000000';
        const safeName = data.name || 'Color sin nombre';
        const confidence = Number.isFinite(Number(data.confidence))
          ? Math.max(0, Math.min(100, Number(data.confidence)))
          : 0;

        state.colorName = safeName;
        state.hex = safeHex;

        colorSwatch.style.backgroundColor = safeHex;
        swatchPlaceholder.hidden = true;
        colorName.textContent = safeName;
        hexValue.textContent = safeHex;
        rgbValue.textContent = `${data.r}, ${data.g}, ${data.b}`;
        confidenceValue.textContent = `${confidence}%`;
        illuminationValue.textContent = 'Blanco de medición';
        speakButton.disabled = false;
        setBusy(false);
        setMessage(`Color detectado: ${safeName} (${safeHex}).`);
      }

      function updateProgress() {
        progressOne.className = '';
        progressTwo.className = '';

        if (['black-ready', 'black-wait'].includes(calibrationStage)) {
          progressOne.classList.add('is-current');
        }

        if (['white-ready', 'white-wait'].includes(calibrationStage)) {
          progressOne.classList.add('is-complete');
          progressTwo.classList.add('is-current');
        }

        if (calibrationStage === 'done') {
          progressOne.classList.add('is-complete');
          progressTwo.classList.add('is-complete');
        }
      }

      function renderCalibrationModal() {
        calibrationNext.disabled = false;
        calibrationCancel.hidden = false;
        updateProgress();

        switch (calibrationStage) {
          case 'black-ready':
            calibrationTitle.textContent = 'Paso 1 de 2: referencia negra';
            calibrationText.textContent =
              'Coloca una tela o cartulina negra mate bajo el sensor, con la caja cerrada y a la distancia final del proyecto.';
            calibrationDetail.textContent =
              'La tira permanecerá encendida con el blanco fijo de medición.';
            calibrationNext.textContent = 'Medir negro';
            break;

          case 'black-wait':
            calibrationTitle.textContent = 'Midiendo el negro…';
            calibrationText.textContent =
              'No muevas la muestra ni abras la caja mientras Arduino toma y filtra varias lecturas.';
            calibrationDetail.textContent = 'Procesando referencia negra.';
            calibrationNext.textContent = 'Midiendo…';
            calibrationNext.disabled = true;
            calibrationCancel.hidden = true;
            break;

          case 'white-ready':
            calibrationTitle.textContent = 'Paso 2 de 2: referencia blanca';
            calibrationText.textContent =
              'Cambia la muestra por una hoja o cartulina blanca mate sin alterar la distancia del sensor.';
            calibrationDetail.textContent = lastCalibrationDetail || 'La referencia negra ya está guardada.';
            calibrationNext.textContent = 'Medir blanco';
            break;

          case 'white-wait':
            calibrationTitle.textContent = 'Midiendo el blanco…';
            calibrationText.textContent =
              'Mantén la superficie blanca completamente quieta mientras se completa la medición.';
            calibrationDetail.textContent = 'Procesando referencia blanca.';
            calibrationNext.textContent = 'Midiendo…';
            calibrationNext.disabled = true;
            calibrationCancel.hidden = true;
            break;

          case 'done':
            calibrationTitle.textContent = 'Calibración completada';
            calibrationText.textContent =
              'Las referencias quedaron validadas y guardadas en la memoria del Arduino. Ya puedes detectar telas.';
            calibrationDetail.textContent = lastCalibrationDetail;
            calibrationNext.textContent = 'Cerrar';
            calibrationCancel.hidden = true;
            break;

          case 'error':
            calibrationTitle.textContent = 'La calibración no fue válida';
            calibrationText.textContent =
              'Revisa que las superficies sean mate, que la caja esté cerrada y que la distancia no cambie entre negro y blanco.';
            calibrationDetail.textContent = lastCalibrationDetail;
            calibrationNext.textContent = 'Reintentar';
            break;

          default:
            break;
        }
      }

      function openCalibrationModal() {
        calibrationStage = 'black-ready';
        lastCalibrationDetail = '';
        renderCalibrationModal();
        calibrationModal.hidden = false;
      }

      function closeCalibrationModal() {
        calibrationStage = 'idle';
        calibrationModal.hidden = true;
      }

      async function sendCommand(command) {
        if (!writer || !state.connected) {
          throw new Error('No existe una conexión serial activa.');
        }

        await writer.write(encoder.encode(`${command}\n`));
      }

      function handleCalibrationResponse(data) {
        const raw = data.raw || {};
        setBusy(false);

        if (data.step === 'black' && data.ok) {
          lastCalibrationDetail =
            `Negro guardado — R ${raw.r}, G ${raw.g}, B ${raw.b}, Clear ${raw.clear}.`;
          calibrationStage = 'white-ready';
          renderCalibrationModal();
          setMessage('Referencia negra guardada. Ahora coloca la superficie blanca.');
          return;
        }

        if (data.step === 'white' && data.ok && data.valid) {
          lastCalibrationDetail =
            `Blanco guardado — R ${raw.r}, G ${raw.g}, B ${raw.b}, Clear ${raw.clear}.`;
          calibrationStage = 'done';
          state.calibrated = true;
          renderDeviceState();
          renderCalibrationModal();
          setMessage('Sensor calibrado correctamente.');
          return;
        }

        lastCalibrationDetail =
          'El blanco no produjo una separación suficiente respecto al negro. Repite el proceso con superficies más limpias y la caja cerrada.';
        calibrationStage = 'error';
        state.calibrated = false;
        renderDeviceState();
        renderCalibrationModal();
        setMessage('La calibración no fue válida.');
      }

      function handleSerialLine(line) {
        if (!line) return;

        let data;
        try {
          data = JSON.parse(line);
        } catch (error) {
          console.warn('Línea serial no reconocida:', line);
          return;
        }

        if (data.type === 'ready') {
          applyDeviceState(data);
          setBusy(false);
          setMessage(data.calibrated
            ? `Arduino listo. Firmware ${data.firmware || ''}. Sensor calibrado.`
            : `Arduino listo. Firmware ${data.firmware || ''}. Falta calibrar el sensor.`);
          return;
        }

        if (data.type === 'busy') {
          setBusy(true);
          setMessage(data.message || 'Arduino está procesando la solicitud…');
          return;
        }

        if (data.type === 'ack') {
          applyDeviceState(data);
          setBusy(false);
          setMessage(data.message || 'Comando ejecutado.');

          if (data.command === 'CAL_RESET') {
            state.calibrated = false;
            renderDeviceState();
          }
          return;
        }

        if (data.type === 'color') {
          updateColorResult(data);
          return;
        }

        if (data.type === 'calibration') {
          handleCalibrationResponse(data);
          return;
        }

        if (data.type === 'error') {
          setBusy(false);
          setMessage(data.message || 'Arduino reportó un error.');

          if (['black-wait', 'white-wait'].includes(calibrationStage)) {
            lastCalibrationDetail = data.message || 'No se pudo leer el sensor.';
            calibrationStage = 'error';
            renderCalibrationModal();
          }
        }
      }

      async function readSerialLoop() {
        if (!port || !port.readable) return;

        keepReading = true;
        reader = port.readable.getReader();

        try {
          while (keepReading) {
            const { value, done } = await reader.read();
            if (done) break;
            if (!value) continue;

            serialBuffer += decoder.decode(value, { stream: true });
            const lines = serialBuffer.split(/\r?\n/);
            serialBuffer = lines.pop() || '';
            lines.forEach((line) => handleSerialLine(line.trim()));
          }
        } catch (error) {
          if (keepReading) {
            console.error(error);
            setMessage('Se perdió la lectura del puerto serial.');
          }
        } finally {
          try {
            reader.releaseLock();
          } catch (error) {
            console.warn(error);
          }
          reader = null;
        }
      }

      async function disconnectArduino({ turnOff = false } = {}) {
        if (turnOff && state.connected && writer) {
          try {
            await sendCommand('STRIP_OFF');
            await sleep(70);
          } catch (error) {
            console.warn(error);
          }
        }

        keepReading = false;

        if (reader) {
          try {
            await reader.cancel();
          } catch (error) {
            console.warn(error);
          }
        }

        if (readPromise) {
          try {
            await readPromise;
          } catch (error) {
            console.warn(error);
          }
          readPromise = null;
        }

        if (writer) {
          try {
            writer.releaseLock();
          } catch (error) {
            console.warn(error);
          }
          writer = null;
        }

        if (port) {
          try {
            await port.close();
          } catch (error) {
            console.warn(error);
          }
          port = null;
        }

        state.connected = false;
        state.stripOn = false;
        state.showOn = false;
        state.busy = false;
        serialBuffer = '';
        closeCalibrationModal();
        renderDeviceState();
      }

      async function connectArduino() {
        if (!('serial' in navigator)) {
          setMessage('Web Serial no está disponible. Abre la página pública en Google Chrome o Microsoft Edge de escritorio.');
          return;
        }

        connectButton.disabled = true;

        try {
          setMessage('Selecciona el puerto USB del Arduino…');
          port = await navigator.serial.requestPort();
          await port.open({ baudRate: BAUD_RATE });

          writer = port.writable.getWriter();
          readPromise = readSerialLoop();

          setMessage('Inicializando Arduino…');
          await sleep(RESET_DELAY_MS);

          state.connected = true;
          renderDeviceState();
          await sendCommand('PING');
          setMessage('Conexión establecida. Consultando estado del dispositivo…');
        } catch (error) {
          console.error(error);
          await disconnectArduino();

          if (error && error.name === 'NotFoundError') {
            setMessage('No se seleccionó ningún puerto.');
          } else {
            setMessage(`No se pudo conectar: ${error && error.message ? error.message : String(error)}`);
          }
        } finally {
          connectButton.disabled = false;
        }
      }

      connectButton.addEventListener('click', async () => {
        if (state.connected) {
          await disconnectArduino({ turnOff: true });
          setMessage('Arduino desconectado.');
          return;
        }

        await connectArduino();
      });

      commandButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          if (!state.connected || state.busy) return;

          const command = button.dataset.command;

          try {
            if (command === 'SCAN') {
              setBusy(true);
              setMessage('Manteniendo la tira encendida y preparando la luz blanca de medición…');
            } else {
              setMessage('Enviando comando al Arduino…');
            }

            await sendCommand(command);
          } catch (error) {
            console.error(error);
            setBusy(false);
            setMessage('No se pudo enviar el comando.');
          }
        });
      });

      startCalibrationButton.addEventListener('click', () => {
        if (!state.connected || state.busy) return;
        openCalibrationModal();
      });

      resetCalibrationButton.addEventListener('click', async () => {
        if (!state.connected || state.busy) return;

        const confirmed = window.confirm(
          '¿Borrar la calibración guardada? Después tendrás que medir nuevamente negro y blanco.'
        );

        if (!confirmed) return;

        try {
          setBusy(true);
          await sendCommand('CAL_RESET');
        } catch (error) {
          console.error(error);
          setBusy(false);
          setMessage('No se pudo borrar la calibración.');
        }
      });

      calibrationNext.addEventListener('click', async () => {
        if (calibrationStage === 'done') {
          closeCalibrationModal();
          return;
        }

        if (calibrationStage === 'error') {
          calibrationStage = 'black-ready';
          lastCalibrationDetail = '';
          renderCalibrationModal();
          return;
        }

        try {
          if (calibrationStage === 'black-ready') {
            calibrationStage = 'black-wait';
            renderCalibrationModal();
            setBusy(true);
            await sendCommand('CAL_BLACK');
            return;
          }

          if (calibrationStage === 'white-ready') {
            calibrationStage = 'white-wait';
            renderCalibrationModal();
            setBusy(true);
            await sendCommand('CAL_WHITE');
          }
        } catch (error) {
          console.error(error);
          setBusy(false);
          lastCalibrationDetail = 'No se pudo enviar el comando de calibración.';
          calibrationStage = 'error';
          renderCalibrationModal();
        }
      });

      calibrationCancel.addEventListener('click', closeCalibrationModal);

      calibrationModal.addEventListener('click', (event) => {
        if (
          event.target === calibrationModal &&
          !['black-wait', 'white-wait'].includes(calibrationStage)
        ) {
          closeCalibrationModal();
        }
      });

      speakButton.addEventListener('click', () => {
        if (!('speechSynthesis' in window) || !state.colorName) return;
        window.speechSynthesis.cancel();
        const speech = new SpeechSynthesisUtterance(
          `El color detectado es ${state.colorName}. Código hexadecimal ${state.hex}.`
        );
        speech.lang = 'es-GT';
        window.speechSynthesis.speak(speech);
      });

      if ('serial' in navigator) {
        navigator.serial.addEventListener('disconnect', async (event) => {
          if (port && event.target === port) {
            await disconnectArduino();
            setMessage('El Arduino fue desconectado físicamente.');
          }
        });
      }

      setCalibrationReady(false);
      renderDeviceState();
    }

    function initializeAll(scope) {
      if (scope.matches && scope.matches('[data-ct-dashboard]')) {
        initializeDashboard(scope);
      }

      scope.querySelectorAll('[data-ct-dashboard]').forEach(initializeDashboard);
    }

    initializeAll(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
